export default __webpack_public_path__ + "media/components/Pages/Index/Images/3-1f81281b70fa5fe5880e3ddeff0f051a.jpg";